/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


export default {
  tasks: [],
  taskTags: [],
  todoSearchQuery: '',
  todoFilter: null,

  addSkillStep: 1,
  searchCompetency: false,
  characteristic: '',
  competency: '',
  initialLevel: '',
  initialLevelText: '',
  trainingDuration: '',
  progressMeasures: [],
  customProgressMeasures: [],
  reviewCompetency: '',
  usedProgressMeasures: [],
}
